import React from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

import {
  AuthTopNavbar,
  AuthRandomQuote,
  AuthLogos,
  LangMenu,
} from 'components';
import './styles.scss';
import routes from '../../routes';
import useTranslation from 'hooks/useTranslation';

const mapState = ({ appData }) => ({
  signupWizardActivePageName: appData.signupWizardActivePageName,
});

const Auth = ({ hasLogos, hasRandomQuote, pageName, children }) => {
  const { getTranslation } = useTranslation('AUTH');
  const { t } = getTranslation();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralParam = queryParams.get('referral');

  const { signupWizardActivePageName } = useSelector(mapState);
  let renderCtaButton = null;
  if (pageName === 'login' || pageName === 'reset-password') {
    renderCtaButton = (
      <Link
        to={
          Boolean(referralParam)
            ? `${routes.signup}?referral=${referralParam}`
            : routes.signup
        }
        className='btn btn-primary'
      >
        {t('AUTH_HEADER_START_FREE')}
      </Link>
    );
  } else if (signupWizardActivePageName === 'signup') {
    renderCtaButton = (
      <Link
        to={
          Boolean(referralParam)
            ? `${routes.login}?referral=${referralParam}`
            : routes.login
        }
        className='btn btn-primary'
      >
        {t('AUTH_HEADER_ENTER_ACCOUNT')}
      </Link>
    );
  }

  const continaerClasses = clsx(
    'container',
    'grid',
    signupWizardActivePageName === 'dashboard-landing' &&
      'reset-grid-template-columns'
  );

  return (
    <div className='auth-root-container'>
      <AuthTopNavbar>{renderCtaButton && renderCtaButton}</AuthTopNavbar>
      <section className='login'>
        <div className={continaerClasses}>
          <div className='lang_menu__wrapper'>
            <LangMenu />
          </div>
          {children}
          {hasRandomQuote &&
            signupWizardActivePageName !== 'dashboard-landing' && (
              <AuthRandomQuote />
            )}
        </div>
      </section>
      {hasLogos && signupWizardActivePageName !== 'dashboard-landing' && (
        <AuthLogos title={t('AUTH_FOOTER_TRUST')} />
      )}
    </div>
  );
};

Auth.propTypes = {
  hasLogos: PropTypes.bool,
  hasRandomQuote: PropTypes.bool,
  pageName: PropTypes.string,
  children: PropTypes.element.isRequired,
};
export default Auth;
